import { ListGroup, Modal } from 'react-bootstrap';

import { BackendStatusData } from 'src/models/GalenData/BackendStatus.model';
import { ModelEnum } from 'src/models/Model.model';
import { Session } from 'src/models/Session.model';

import useUiTranslation from 'src/hooks/useUiTranslation';

import GlobalStack from './GlobalStack';
import ModelStack from './ModelStack';

const modelToBackendStatusObject: Record<
  ModelEnum,
  keyof Omit<BackendStatusData, 'GlobalStatus' | 'SessionId'>
> = {
  [ModelEnum.DR_US]: 'DrusStatus',
  [ModelEnum.DR_EU]: 'DreuStatus',
  [ModelEnum.AMD_EU]: 'AmdeuStatus',
  [ModelEnum.GLAUCOMA_EU]: 'GlaucomaeuStatus',
  [ModelEnum.CVD_EU]: 'CvdeuStatus',
  [ModelEnum.CVD_AU]: 'CvdauStatus',
  [ModelEnum.DR_EU_SMALL]: 'DreuSmallStatus',
  [ModelEnum.AMD_EU_SMALL]: 'AmdeuSmallStatus',
  [ModelEnum.GLAUCOMA_EU_SMALL]: 'GlaucomaeuSmallStatus',
  [ModelEnum.CVD_EU_SMALL]: 'CvdeuSmallStatus',
  [ModelEnum.CVD_AU_SMALL]: 'CvdauSmallStatus',
  [ModelEnum.VESSEL_SEGMENTATION]: 'VesselSegStatus',
};

interface ProgressModalBodyProps {
  session: Session;
  shouldShowDilationRecommendation: boolean;
  shouldShowReachMaxRecommendedAttempts: boolean;
  status: BackendStatusData;
  models: ModelEnum[];
}

const ProgressModalBody = ({
  session,
  shouldShowDilationRecommendation,
  shouldShowReachMaxRecommendedAttempts,
  status,
  models,
}: ProgressModalBodyProps) => {
  const { tPages } = useUiTranslation();

  return (
    <Modal.Body className="p-4">
      <ListGroup>
        <ListGroup.Item className="p-4">
          <GlobalStack session={session} status={status} />
        </ListGroup.Item>
        {models.map((model, index) => (
          <ListGroup.Item key={index} className="p-4 ps-5">
            <ModelStack
              name={modelToBackendStatusObject[model]}
              status={status}
            />
          </ListGroup.Item>
        ))}
      </ListGroup>

      {shouldShowDilationRecommendation && (
        <p className="my-2">
          <i>{tPages('newExam.dilationRecommendation')}</i>
        </p>
      )}
      {shouldShowReachMaxRecommendedAttempts && (
        <p className="text-danger my-2">
          <i>{tPages('newExam.reachMaxRecommendedAttempts')}</i>
        </p>
      )}
    </Modal.Body>
  );
};

export default ProgressModalBody;
